module.exports = __webpack_public_path__ + "static/media/first.c32b0968.png";